<template>
<div>
    <v-container fluid :class="{ 'px-2': $vuetify.breakpoint.smAndDown, 'pt-md-3 pt-1': true}">
        <div class="py-2 section-title">{{ $t('dashboard.widget.title') }}</div>

        <im-widgets :hotel_id="hotel.id" :currency="hotel.currency" />

        <div class="py-md-2 section-title">{{ $t('dashboard.bookings.title') }}</div>

        <!-- reservation filters -->
        <im-filters @filter="filterResevations($event)" @search="searchRerersation($event)" @fields="updateFields($event)" />

        <im-table-header :items="im_header" />

        <!--./ data table -->
        <div class="" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="topbar" style="position: absolute" />
        </div>
        <template v-if="items.length > 0">
            <!-- DATATABLE ROWS -->
            <v-card tile flat style="background-color: transparent !important;">
                <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                    <template v-slot:item="props">
                        <im-reservation-item :item="props.item" @click="seeReservation(props.item)" />
                    </template>
                </v-data-iterator>
            </v-card>
        </template>
        <div v-else>
            <div class="important pa-2 text-center">
                {{ $t('dashboard.bookings.table_message') }}
            </div>
        </div>

    </v-container>
    <!-- dialog reservation -->
    <v-dialog v-model="dialog_reservation" width="1460" max-height="600" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card flat tile>
            <v-card-title class="headline">
                {{ $t('dashboard.booking.modal.title') }}
                <v-spacer />
                <v-btn icon left @click="dialog_reservation=false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <im-reservation-modal v-if="reservation.id" :reservation_id="reservation.id" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="printReservation('print-item')">
                    {{ $t('button.print') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog reservation -->

    <im-print-modal class="printMe" :reservation_id="reservation.id" id="print-item"></im-print-modal>
</div>
</template>
<script>
import {
    mapActions
} from 'vuex';
import qs from "qs";
import defaults from "../../components/utils/PropDefaults.js";
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMReservationItem from '../../components/items/Dashboard/ReservationCardDashboard.vue';
import IMWidgets from '../../components/items/Dashboard/Widgets.vue';
import IMFilters from '../../components/items/Dashboard/ReservationsFilters.vue';
import IMReservationModal from '../../components/items/Dashboard/ReservationModal.vue';
import IMItemReservations from '../../components/utils/print/ItemReservation.vue';

export default {
    props: ['hotel'],
    name: `dashboard`,
    components: {
        'im-table-header': IMTableHeader,
        'im-reservation-item': IMReservationItem,
        'im-reservation-modal': IMReservationModal,
        'im-print-modal': IMItemReservations,
        'im-widgets': IMWidgets,
        'im-filters': IMFilters,
    },

    beforeRouteEnter(to, from, next) {
        let path = localStorage.getItem('path');
        if(path) {
            localStorage.removeItem('path');
            next(path);
        } else {
            next()
        }
    },

    data() {
        return {
            dialog_reservation: false,
            reservation: defaults.reservation_item,
            // time variables
            timestamp_after: null,
            timestamp_before: null,
            check_in_after: null,
            check_in_before: null,
            check_out_after: null,
            check_out_before: null,

            fields: [],
            search: null,

            filters: {
                hotel_id: null,
                status: null,
                timestamp: {
                    before: null,
                    after: null,
                },
                check_in: {
                    before: null,
                    after: null,
                },
                check_out: {
                    before: null,
                    after: null,
                },
            },

            // table items
            items: [],
            loading: false,
            total: 0,
            page: 1,
            size: 5,
            itemsPerPageOptions: [5, 10, 15, 25],
        }
    },

    computed: {
        // imemento table
        im_header() {
            return [
                {
                    text: this.$t('dashboard.bookings.table_header.hotel'),
                    width: "16.66%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('dashboard.bookings.table_header.room'),
                    width: "23%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('dashboard.bookings.table_header.booking_date'),
                    width: "24.67%",
                    align: "center",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "CI",
                    width: "3%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "CO",
                    width: "3%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('dashboard.bookings.table_header.client'),
                    width: "21.34%",
                    align: "center",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('dashboard.bookings.table_header.price'),
                    width: "8.33%",
                    align: "center",
                    sortable: false,
                    sort_dir: null,
                },
            ]
        }
    },

    created() {
        this.getReservations();
    },

    watch: {
        page: {
            handler() {
                if(!this.hotel.id) {
                    return;
                }
                this.getReservations();
            }
        },
        size: {
            handler() {
                if(!this.hotel.id) {
                    return;
                }
                this.getReservations();
            }
        },
        hotel: {
            handler: function () {
                this.getReservations();
            }
        },
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getReservations() {
            if(!this.hotel.id) {
                return
            }

            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }


            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations';

            // setup query params
            let options = {
                params: {
                    size: this.size,
                    page: this.page,
                    query: search,
                    search_fields: this.fields,
                    hotel_id: this.hotel.id,
                    status: this.filters.status,
                    created_at: {
                        from: this.filters.timestamp.after,
                        until: this.filters.timestamp.before
                    },
                    check_in: {
                        from: this.filters.check_in.after,
                        until: this.filters.check_in.before
                    },
                    check_out: {
                        from: this.filters.check_out.after,
                        until: this.filters.check_out.before
                    },
                },
                paramsSerializer: qs.stringify
            };

            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data.data;
                    this.total = response.data.pagination.total;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        seeReservation(current_reservation) {
            this.reservation = this.$clone(current_reservation);
            this.dialog_reservation = true;
        },

        // printReservation(divPrint) {
        //     let elem = document.getElementById(divPrint);
        //     let domClone = elem.cloneNode(true);
        //     let printSection = document.getElementById("printSection");
        //
        //     if(!printSection) {
        //         printSection = document.createElement("div");
        //         printSection.id = "printSection";
        //         printSection.innerHTML = "";
        //         printSection.appendChild(domClone);
        //         document.body.appendChild(printSection);
        //     } else {
        //         printSection.innerHTML = "";
        //         printSection.appendChild(domClone);
        //     }
        //
        //     window.print();
        // },
        printReservation(divPrint) {
            let elem = document.getElementById(divPrint);
            let domClone = elem.cloneNode(true);
            let printSection = document.getElementById("printSection");

            if(!printSection) {
                printSection = document.createElement("div");
                printSection.id = "printSection";
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
                document.body.appendChild(printSection);
            } else {
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
            }
            window.print();
        },


        searchRerersation(value) {
            this.search = value;
            this.page = 1;
            this.getReservations();
        },

        updateFields(value) {
            this.fields = value;
            if(this.search) {
                this.page = 1;
                this.getReservations();
            }
        },

        filterResevations(value) {
            this.filters = value;
            this.page = 1;
            this.getReservations();
        }
    }
}
</script>
<style media="screen" >
.section-title {
    padding-left: 5px;
    font-size: 25px;
    font-weight: 600;
}
</style>
